import Vue from 'vue';

/**
 * 将表单转换成JSON对象
 * @param {*} form form元素
 */
function formFormat(form) {
    var arr = {};
    for (var i = 0; i < form.elements.length; i++) {
        var feled = form.elements[i];
        switch (feled.type) {
            case undefined:
            case 'button':
            case 'file':
            case 'reset':
            case 'submit':
                break;
            case 'checkbox':
            case 'radio':
                if (!feled.checked) {
                    break;
                }
            // eslint-disable-next-line no-fallthrough
            default:
                if (arr[feled.name]) {
                    arr[feled.name] = arr[feled.name] + ',' + feled.value;
                } else {
                    arr[feled.name] = feled.value;
                }
        }
    }

    return arr
}

Vue.prototype.$formFormat = formFormat;

export default formFormat;
